import React from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import ExcluirAEJ from 'templates/Integracoes/AEJ/ExcluirRelatorio'
import GerarRelatorioAEJ from 'templates/Integracoes/AEJ/NovoRelatorio'
import { GerarAfdModal } from 'templates/Integracoes/AFD/modal/GerarAfd'
import { ImportAfd } from 'templates/Integracoes/AFD/modal/ImportAfd'
import ExportacaoTxt from 'templates/Integracoes/FolhaPagamento/modal/ExportacaoTxt'
import AdicionarRep from 'templates/Integracoes/REPs/components/modals/Adicionar'
import AssociarFuncionariosRep from 'templates/Integracoes/REPs/components/modals/AssociarFuncionarios'
import EditarRep from 'templates/Integracoes/REPs/components/modals/Editar'
import ExcluirRep from 'templates/Integracoes/REPs/components/modals/Excluir'

const Afd = React.lazy(() => import('pages/Afd'))
const GerarAej = React.lazy(() => import('pages/GerarAej'))
const Reps = React.lazy(() => import('pages/Reps'))
const FolhaPagamento = React.lazy(() => import('pages/FolhaPagamento'))
const HistoricoExportacaoFolha = React.lazy(
    () => import('templates/Integracoes/FolhaPagamento/modal/Historico'),
)

const base = '/integracoes'

export const integracoes: RouteObject = {
    path: base,
    children: [
        {
            path: base + '/afd',
            element: <Afd />,
            children: [
                {
                    path: base + '/afd/importar',
                    element: <ImportAfd />,
                },
                {
                    path: base + '/afd/exportar',
                    element: <GerarAfdModal />,
                },
            ],
        },
        {
            path: base + '/aej',
            element: <GerarAej />,
            children: [
                {
                    path: base + '/aej/relatorio',
                    element: <GerarRelatorioAEJ />,
                },
                {
                    path: base + '/aej/:id/excluir',
                    element: <ExcluirAEJ />,
                },
            ],
        },
        {
            path: base + '/importar-funcionarios',
            element: <Navigate to="/cadastros/funcionarios/importar" />,
        },
        {
            path: base + '/exportar-funcionarios',
            element: <Navigate to="/cadastros/funcionarios/exportar" />,
        },
        {
            path: base + '/importar-exportar-funcionarios',
            element: <Navigate to="/cadastros/funcionarios" />,
        },
        {
            path: base + '/reps',
            element: <Reps />,
            children: [
                {
                    path: base + '/reps/adicionar',
                    element: <AdicionarRep />,
                },
                {
                    path: base + '/reps/:id/excluir',
                    element: <ExcluirRep />,
                },
                {
                    path: base + '/reps/:id/editar',
                    element: <EditarRep />,
                },
                {
                    path: base + '/reps/:id/associar',
                    element: <AssociarFuncionariosRep />,
                },
            ],
        },
        {
            path: base + '/folha-pagamento',
            element: <FolhaPagamento />,
            children: [
                {
                    path: base + '/folha-pagamento/exportar-txt',
                    element: <ExportacaoTxt />,
                },
                {
                    path: base + '/folha-pagamento/historico',
                    element: <HistoricoExportacaoFolha />,
                    index: true,
                },
            ],
        },
    ],
}
